import React from 'react';
import {FormattedMessage} from 'react-intl';
import styles from './Terms.module.scss';

const Terms = () => {

  return (
    <div
      className={styles.termsContainer}
      data-testid={'Terms'}
      dir={'rtl'}
    >
      <div className={styles.termsHeader}>
        <FormattedMessage
          id={'inviteFriend-page-terms-title'}
          defaultMessage={'Terms \"A friend brings a friend\"'}
        />
      </div>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p1-title'}
          defaultMessage={'Introduction:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-1'}
              defaultMessage={'Self Employed Ltd. P.F. 513500181 (hereinafter: the '}
            />
          </span>
          <span className={styles.boldText}>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-2'}
              defaultMessage={'\"Company\"'}
            />
          </span>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-3'}
              defaultMessage={') holds a \"Friend Brings a Friend\" promotion (hereinafter: the '}
            />
          </span>
          <span className={styles.boldText}>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-4'}
              defaultMessage={'"Promotion\"'}
            />
          </span>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-5'}
              defaultMessage={'). The conditions for participation in the promotion will be stated below in these terms (hereinafter: the '}
            />
          </span>
          <span className={styles.boldText}>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-6'}
              defaultMessage={'\"Terms\"'}
            />
          </span>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p1-7'}
              defaultMessage={').'}
            />
          </span>
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p1-text-p2'}
            defaultMessage={'Introduction:'}
          />
        </li>
        <li>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p3-1'}
              defaultMessage={'A notice regarding the conduct of the sale will be published in posts on Facebook and on the company\'s website at the address: '}
            />
          </span>
          <a
            href="https://www.atzmai.co.il"
            target={"blank"}
            className={styles.link}
          >
            https://www.atzmai.co.il
          </a>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p1-text-p3-2'}
              defaultMessage={'. The company reserves the right to advertise the promotions through additional means.'}
            />
          </span>
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p2-title'}
          defaultMessage={'Interpretation:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p2-text-p1'}
            defaultMessage={'The introduction to the terms and the definitions therein are an integral part of it.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p2-text-p2'}
            defaultMessage={'In the event of any contradiction and/or inconsistency between the provisions of these terms and other publications regarding the promotion, the provisions of these terms shall prevail in all respects.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p2-text-p3'}
            defaultMessage={'The articles of the statute were written in the singular and in the masculine gender for reasons of convenience only. The terms refer to members of both sexes, singular as plural and vice versa.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p3-title'}
          defaultMessage={'Benefit:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p3-text-p1'}
            defaultMessage={'One month of free commission for the account maintained by the company in the name of the company\'s customer, in the new customer\'s third salary month.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p4-title'}
          defaultMessage={'Eligibility for a benefit:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p1'}
            defaultMessage={'For each member who is invited (hereinafter: the "invited member") by the customer of the company (hereinafter: the "inviting customer") to register and open an account with an independent salaried company, the ordering customer will be entitled to a benefit and provided that the following sequence of actions is carried out for him:'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p2'}
            defaultMessage={'The invited member is registered by a special link that he received from the inviting customer during the account opening procedure.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p3'}
            defaultMessage={'The invited member opened an account and ordered at least one invoice and even received payment for it.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p4'}
            defaultMessage={'The invited member has not closed his account with a self-employed person within three months and continues to issue invoices and receipts during these months.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p5'}
            defaultMessage={'It is clarified that if more than one customer invited a certain invited member, only one inviting customer will be entitled to the benefit.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p4-text-p6'}
            defaultMessage={'Without deviating from the provisions of these terms and the provisions of any law, the organizer of the promotion shall be entitled not to give the benefit to an inviting customer who obtained his right to the benefit through a criminal act or an act that is illegal or contrary to the provisions of these terms, and this at the sole discretion of the company.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p5-title'}
          defaultMessage={'Notification of receiving the benefit:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p5-text-p1'}
            defaultMessage={'The company will credit the ordering customer\'s account with a benefit three months later from the date of receipt of payment by the invited member.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p5-text-p2'}
            defaultMessage={'In doing so, the company will discharge its obligation regarding the delivery of the benefit.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p6-title'}
          defaultMessage={'Promotion period:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p6-text-p1-1'}
              defaultMessage={'The promotion will be valid from 01/11/2020 until 31/12/2023 inclusive (hereinafter: '}
            />
          </span>
          <span className={styles.boldText}>
            <FormattedMessage
              id={'inviteFriend-page-terms-p6-text-p1-2'}
              defaultMessage={'"Promotion Period"'}
            />
          </span>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p6-text-p1-3'}
              defaultMessage={').'}
            />
          </span>
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p6-text-p2'}
            defaultMessage={'The company hereby reserves the right to bring forward or postpone the end date of the promotion period, without prior notification, and no claim and/or demand and/or claim will be heard in connection therewith.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p6-text-p3'}
            defaultMessage={'No doubling of promotions.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p7-title'}
          defaultMessage={'General:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <span>
            <FormattedMessage
              id={'inviteFriend-page-terms-p7-text-p1'}
              defaultMessage={'The terms of the official promotion will be available for review on the website '}
            />
          </span>
          <a
            href="https://www.atzmai.co.il"
            target={"blank"}
            className={styles.link}
          >
            https://www.atzmai.co.il
          </a>
          <span>.</span>
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p2'}
            defaultMessage={'In any case where the participant of the promotion violates the provisions of the terms and/or an obligation of his obligations towards the organizer of the promotion. The organizer of the promotion will be entitled to cancel his participation in the promotion and/or his winning and the participant in the promotion waives in advance any demand and/or claim and/or claim against the company in connection with the above.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p3'}
            defaultMessage={'The company will be entitled to update the details of the promotion and/or these terms at its sole discretion, at any time and without the need to provide advance notice, and none of the participants will have any claim and/or claim against the company in this regard.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p4'}
            defaultMessage={'By participating in the promotion, the participant in the promotion agrees, confirms and declares that he has read the terms and that he accepts its instructions, and even if he has not read the terms, he agrees that these terms will apply to him and will bind him in all respects.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p5'}
            defaultMessage={'The company will be the sole and final arbiter in all matters relating to the promotion and regarding any question that may arise during and/or in connection with it and/or any problem and/or any unexpected situation that may arise during the promotion, whether or not expressly stated in these terms, and the participant will not have any claim due to so.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p6'}
            defaultMessage={'Any tax, deduction or demand for payment of tax, of any kind, will apply to the winner and will be at his expense and responsibility only. The organizer of the promotion will be entitled to transfer to the tax authorities, if required by law, the details of the winner and/or withholding tax. The competitors hereby give permission to the organizer of the promotion and/or someone on her behalf, to set off, deduct or reduce any required payment, in accordance with the law. The organizer of the promotion and/or anyone on her behalf will not be responsible for paying any tax in connection with the winnings.'}
          />
        </li>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p7-text-p7'}
            defaultMessage={'The participant hereby releases the company, its directors, employees and anyone on their behalf, from any claim, demand and/or claim in connection with the promotion, participation (or non-participation) and/or winning thereof, and will not be entitled to any compensation, indemnification or relief for them. The participant declares that this commitment is irrevocable and cannot be changed or cancelled.'}
          />
        </li>
      </ul>
      <div className={styles.termsTitle}>
        <FormattedMessage
          id={'inviteFriend-page-terms-p8-title'}
          defaultMessage={'Law, judgment:'}
        />
      </div>
      <ul className={styles.termsListContainer}>
        <li>
          <FormattedMessage
            id={'inviteFriend-page-terms-p8-text-p1'}
            defaultMessage={'The law that applies to this terms and everything that derives from it is Israeli law only. The exclusive jurisdiction is given to the competent courts in the Tel Aviv-Jaffa district.'}
          />
        </li>
      </ul>
    </div>
  );
};

export default Terms;
